// @flow
import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import Path from 'routes/path'
import moment from 'moment'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ReservationModel from 'frontend_core/dist/model/Reservation'
import SMConst from 'frontend_core/dist/constants/sm-const'

import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'

import MainTemplate from 'components/templates/MainTemplate'
import ReservationCancelPage from 'components/pages/ReservationCancelPage'
import ReservationCancelForm from 'components/organisms/ReservationCancelForm'
import LoadingView from 'components/atoms/LoadingView'
import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'
import graphql from './graphql'
import { accountLoginUrl } from 'frontend_core/dist/helpers/url'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    isLoading?: ?boolean,
    cancelReason?: ?number,
    reasonDesc?: ?string,
    isModalActive?: ?boolean,
  },
  actions: {
    setUIState: Function,
    fetchReservationDetail: Function,
    cancelReservation: Function,
  },
  reservationDetail: ReservationDetailState,
}

class ReservationCancelPageContainer extends Component<PropTypes, *, *> {
  static async getInitialProps({ req, res, params, config, isLogin }) {
    if (!isLogin)
      return { redirect: { to: accountLoginUrl(config), status: 302 } }
    return
  }

  constructor(props: PropTypes) {
    super(props)
    this.onClickSendConfirm = this.onClickSendConfirm.bind(this)
    this.onClickSend = this.onClickSend.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.onClickBackToMessage = this.onClickBackToMessage.bind(this)
  }

  componentDidMount() {
    const { actions, reservationDetail, match, config, data } = this.props
    const { detail, messages } = reservationDetail

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
    // モーダル閉じる
    this.closeModal()
    window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, reservationDetail, match, config, data } = this.props
    const { reservationDetail: prevReservationDetail } = prevProps
    // エラー系の表示
    if (
      reservationDetail.failedCancelMessage !== null &&
      prevReservationDetail.failedCancelMessage === null
    ) {
      antdMessage.warning(reservationDetail.failedCancelMessage)
    }
  }

  onClickBackToMessage: Function
  onClickBackToMessage(e: Event) {
    const { history, location, match } = this.props
    e.preventDefault()
    history.push(location.pathname)
    history.replace(Path.reservationDetail(match.params.reservationId))
  }

  onClickSendConfirm: Function
  onClickSendConfirm(e: Event) {
    const { actions, match } = this.props
    e.preventDefault()
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isModalActive: true,
    })
  }

  onClickSend: Function
  onClickSend() {
    const { actions, data, match, ui } = this.props
    console.log(actions)
    actions.cancelReservation({
      userId: data.viewer.id,
      reservationId: match.params.reservationId,
      cancelReason: ui.cancelReason,
      description: ui.reasonDesc,
    })
  }

  closeModal: Function
  closeModal() {
    const { actions } = this.props
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      isModalActive: false,
    })
  }

  render() {
    const {
      location,
      history,
      match,
      reservationDetail,
      ui,
      actions,
      data,
    } = this.props
    const { detail, messages } = reservationDetail

    // キャンセルできない予約で直リンクした場合はメッセージ画面に戻す
    if (detail.id && !detail.can_be_cancelled) {
      if (!reservationDetail.successCancel) {
        antdMessage.warning(
          i18n.t('page.dashboard.reservation.error.cannotCancel'),
        )
      }
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationCancel.title', {
          id: detail.id || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <ReservationCancelPage
          sidebarComponent={<ReservationSidebarContainer />}
          isShowContentsSp
          closeModal={this.closeModal}
          isModalActive={!!ui.isModalActive}
          onClickPositiveButton={this.onClickSend}
          isLoading={ui.isLoading}
        >
          <ReservationCancelForm
            cancelReason={ui.cancelReason}
            onChangeCancelReason={(cancelReason: number) =>
              actions.setUIState(containerIds.RESERVATION_DETAIL, {
                cancelReason,
              })
            }
            isActiveReasonDesc={ui.cancelReason === 5}
            reasonDesc={ui.reasonDesc}
            onChangeReasonDesc={(e: SyntheticInputEvent) =>
              actions.setUIState(containerIds.RESERVATION_DETAIL, {
                reasonDesc: e.target.value,
              })
            }
            errorReasonDesc={
              ui.reasonDesc ? null : i18n.t('error.formError.inputRequired')
            }
            onClickBackToMessage={this.onClickBackToMessage}
            onClickSend={this.onClickSendConfirm}
            isSendButtonDisabled={
              !ui.cancelReason || (ui.cancelReason === 5 && !ui.reasonDesc)
            }
            hrefCancelPolicy={Path.roomCancelPolicy(detail.room || {})}
          />
        </ReservationCancelPage>
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...ReservationDetailActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationCancelPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationCancelPage/index.jsx